//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {isMobile} from 'mobile-device-detect';

export default {
    props: {
        store: {
            type: Object,
        },
    },
    computed: {
        is_mobile: function() {
            return isMobile
        },
        range: function () {
            return isMobile ? 1 : 3
        },
        paginationClass: function() {
            return this.$variables.post_pagination_link == 'page_xofy'? `pagination mt-4 justify-content-between` : 'pagination mt-4 justify-content-center'
        },
        previousText: function() {
            return this.$variables.post_pagination_labels === 'adjacent'? this.$t('i18n.previous') : (this.$variables.post_pagination_labels === 'adjacent_page'? this.$t('i18n.previousPage') : '&nbsp;')
        },
        nextText: function() {
            return this.$variables.post_pagination_labels === 'adjacent'? this.$t('i18n.next') : (this.$variables.post_pagination_labels === 'adjacent_page'? this.$t('i18n.nextPage') : '')
        },
        total_pages: function() {
            return this.store.state.total_pages
        },
        current_page: function() {
            return parseInt(this.store.state.page, 10)
        },
        pageXofY: function() {
            return this.$t('i18n.pageXofY', {x: this.current_page, y: this.total_pages})
        }
    },
    methods: {
        pageCallback(page) {
            let url = window.location.href.split('?')[0] + '?page=' + page
            if(!this.$variables.post_pagination_reload) {
                this.store.state.page = page
                window.history.pushState({}, "", url)
                $('html, body').animate({
                    scrollTop: 0
                }, 200);
            } else {
                window.location.replace(url);
            }
        }
    },
};
